
'use strict';

const build_config = {
    git_version: "before",
    git_branch: "master",
    git_commit: "ec49bab4cee6dca57bfd9f9f5402556bec2db7e5",
    wrb_update: "79",
};  

export default build_config;
